import { render, staticRenderFns } from "./GapInfo.vue?vue&type=template&id=1b37ebbe&scoped=true"
import script from "./GapInfo.vue?vue&type=script&lang=js"
export * from "./GapInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b37ebbe",
  null
  
)

export default component.exports